import { useCallback }         from 'react';
import { teacherUrlStateType } from 'types';

const useShowTeacherUrlModal = ( setTeacherUrlState: (val: teacherUrlStateType) => void ) => {

    const showTeacherUrlModal = useCallback(() => {
        import("functions/actions/show_teacher_url_modal").then(func => {
          func.showTeacherUrlModal(setTeacherUrlState)
        }); 
    },[setTeacherUrlState])
  
  return showTeacherUrlModal;
    
}

export default useShowTeacherUrlModal